/**
 * Словарь «код → подпись» на языке интерфейса.
 *
 * Многие модули экспортируют `Record<код, строка>`, и потребители читают его
 * как `LABELS[code]`. Хранить там готовые строки нельзя: они застыли бы на
 * языке загрузки (`tr` на верхнем уровне модуля). Поэтому словарь описаний
 * (`defineMessages`) превращается в объект с геттерами: каждое чтение зовёт
 * `tr` в момент обращения, а вид `LABELS[code]` для потребителей не меняется.
 */
import type { Message } from '../../i18n/define';
import { tr } from '../../i18n/runtime';

export function messageRecord<K extends string>(dictionary: Record<K, Message>): Record<K, string> {
  const out = {} as Record<K, string>;
  for (const key of Object.keys(dictionary) as K[]) {
    Object.defineProperty(out, key, { enumerable: true, get: () => tr(dictionary[key]) });
  }
  return out;
}
